import(/* webpackMode: "eager", webpackExports: ["AppsSection"] */ "/app/apps/todoist-landing-pages/app/components/apps-section/apps-section.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/components/custom-page/apps-block/apps-block.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/components/custom-page/button/button.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/components/custom-page/cards-block/cards-block.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["PricingBox"] */ "/app/apps/todoist-landing-pages/app/components/custom-page/elevated-block/pricing-box/pricing-box.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/components/custom-page/feature-pages-block/feature-pages-block.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/app/apps/todoist-landing-pages/app/components/custom-page/hero-section/hero-section.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/components/custom-page/marquee/logo-marquee.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/components/custom-page/custom-page.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/components/custom-page/arcade-embed/arcade-embed.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["FaqPrefooter","TwoColumnPrefooter"] */ "/app/apps/todoist-landing-pages/app/components/custom-page/prefooter/prefooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollingBlock"] */ "/app/apps/todoist-landing-pages/app/components/custom-page/scrolling-block/scrolling-block.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/components/custom-page/social-proof/accolades/nyt.svg");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/components/custom-page/social-proof/customer-logos/arrow.svg");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/components/custom-page/two-columns/two-columns.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/components/custom-page/social-proof/accolades/reviews-section.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/components/custom-page/social-proof/social-proof.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/components/custom-page/social-proof/publication-quotes/publication-quote.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["VideoColumn"] */ "/app/apps/todoist-landing-pages/app/components/custom-page/two-columns/video-column.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoBlock"] */ "/app/apps/todoist-landing-pages/app/components/custom-page/video-block/video-block.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FlexibleViewsSection"] */ "/app/apps/todoist-landing-pages/app/components/flexible-views-section/flexible-views-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserContextV2Provider"] */ "/app/apps/todoist-landing-pages/app/services/providers/contexts/user-context.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/components/icon-card/icon-card.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/components/SectionHeader/SectionHeader.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/components/container-two-column/container-two-column.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/components/text-lock-up/text-lock-up.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/components/alert/alert.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/components/marquee/marquee.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/components/award/award.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/components/handwritten-box/handwritten-box.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/public/static/award/leaf.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/packages/icons/dist/brand-icons.js");
;
import(/* webpackMode: "eager", webpackExports: ["ArcadeEmbed"] */ "/app/packages/marketist/dist/components/arcade-embed/arcade-embed.js");
;
import(/* webpackMode: "eager" */ "/app/packages/marketist/dist/components/Button/Button.js");
;
import(/* webpackMode: "eager" */ "/app/packages/marketist/dist/components/image/image.js");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/packages/marketist/dist/components/Link/Link.js");
